import React from "react"
import { Redirect } from "react-router-dom"

export default function EstimateVizHome({ match }) {
  return <Redirect to={match.url + "/bubble"} />
}
